import { Cancelled, is } from '@bldsoft/cappie/rest'

export function isRequestCancelled(error: unknown): boolean {
  return is(error, Cancelled)
}
